import React from 'react';
import { ButtonContainer, ButtonItem } from './TabPill.styled';
import { ITabPillOption, ITabPill } from './../../../@types/tabpill';
import { Body4 } from './../../typography';

export function TabPill ({ options, handleClick, selected }: ITabPill) {
  return (
    <ButtonContainer>
      {options &&
        options.map((option: ITabPillOption) => (
          <ButtonItem
            key={option.value}
            selected={option.value === selected}
            onClick={() => {
              handleClick(option.value);
            }}
          >
            <Body4
              color={option.value === selected ? 'verdigrisDark' : 'eerieBlack'}
            >
              {option.label}
            </Body4>
          </ButtonItem>
        ))}
    </ButtonContainer>
  );
}
